var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MultiSelection, OptionSegment } from '@folio/stripes/components';
import fuzzysort from 'fuzzysort';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
var ServicePointAssignmentField = function (props) {
    var formatter = function (_a) {
        var option = _a.option, searchTerm = _a.searchTerm;
        if (typeof searchTerm !== 'string' || searchTerm === '') {
            return React.createElement(OptionSegment, null, option.name);
        }
        var result = fuzzysort.single(searchTerm, option.name);
        // this should not happen as all elements passed to this function should have been found
        if (result === null)
            return null;
        return (React.createElement(OptionSegment, { key: option.id }, fuzzysort.highlight(result, function (m, i) { return (React.createElement("strong", { key: i }, m)); })));
    };
    return (React.createElement(Field, { name: "service-points", error: props.error, render: function (fieldProps) { return (React.createElement(MultiSelection, __assign({}, fieldProps, { label: React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.field.servicePoints" }), formatter: formatter, filter: function (filterText, list) {
                if (typeof filterText !== 'string' || filterText === '') {
                    return { renderedItems: list, exactMatch: false };
                }
                // must spread and re-collect into a new array, as the returned array is immutable
                var results = __spreadArray([], fuzzysort.go(filterText, props.servicePoints, { key: 'name' }), true);
                // score descending, then name ascending
                // fixes "service point 1".."service point 4" etc having undefined order
                results.sort(function (a, b) {
                    if (a.score === b.score) {
                        return a.target.localeCompare(b.target);
                    }
                    return -(a.score - b.score);
                });
                return {
                    // retrieve the original service point
                    renderedItems: results.map(function (result) { return result.obj; }),
                    exactMatch: !!list.filter(function (sp) { return sp.name === filterText; }).length,
                };
            }, itemToString: function (servicePoint) {
                if (servicePoint) {
                    return servicePoint.name;
                }
                else {
                    return '';
                }
            }, dataOptions: props.servicePoints }))); } }));
};
export default ServicePointAssignmentField;
